<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold pt-2" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <button type="button"
            v-for="(item, index) in items"
            :key="index"
            :class="['btn btn-sm btn-outline-filter btn-staender', filterUiState('stand', item.value)]"
            v-on:click="selectValue(item.value)">{{ item.title }}</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionStand',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Ständer',
      items: [
        { title: '60/80', value: 'stae-80' },
        { title: '60/100', value: 'stae-100' },
        { title: '60/140', value: 'stae-140' },
        { title: '60/160', value: 'stae-160' },
        { title: '60/180', value: 'stae-180' },
        { title: '60/200', value: 'stae-200' },
        { title: '60/240', value: 'stae-240' },
        { title: '70/165', value: 'stae-165' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('stand', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value !== null ? Number(value.split('-')[1]) : null
      })

      this.$store.dispatch('filter/setValue', {
        name: 'stand',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
